export const FOLHA_PONTO_OLD = 'FOLHA_PONTO_OLD';
export const FOLHA_PONTO = 'FOLHA_PONTO';
export const PROGRAMACAO_DIARIA = 'PROGRAMACAO_DIARIA';
/** Painel web: visão agregada (dia + itens). Não confundir com PROGRAMACAO_DIARIA (mobile sync V2). */
export const PROGRAMACAO_DIARIA_DIA = 'PROGRAMACAO_DIARIA_DIA';
export const OLERITE = 'OLERITE';
export const FOLHA_PONTO_FULL_ACCESS = 'FOLHA_PONTO_FULL_ACCESS';
export const PROCEDIMENTO_NORMAS_FULL_ACCESS = 'PROCEDIMENTO_NORMAS_FULL_ACCESS';
export const PRODUTO_PEDIDO_DELETE_ACCESS = 'PRODUTO_PEDIDO_DELETE_ACCESS';
export const NSIR_STATUS_UPDATE = 'NSIR_STATUS_UPDATE';
export const AUDITORIA_NSIR = 'AUDITORIA_NSIR';
export const PEDIDO_VOO = 'PEDIDO_VOO';
export const PEDIDO_VOO_ADMIN = 'PEDIDO_VOO_ADMIN';
export const CARTAO_ADMIN = 'CARTAO_ADMIN';
export const RELATORIO_VEICULAR_ACCESS = 'RELATORIO_VEICULAR_ACCESS';
export const RELATORIO_FINANCEIRO_ACCESS = 'RELATORIO_FINANCEIRO_ACCESS';
export const RELATORIO_USO_MUTUO = 'RELATORIO_USO_MUTUO';
export const CALENDARIO_FERIADOS_ADMIN = 'CALENDARIO_FERIADOS_ADMIN';